// Source: CREON_consumers_UA_programming.xlsx (RU-KZ-UA sheet)
// Questionnaire content only; programming instructions are interpreted by fusion.js.
const CREON_CONTENT_UA = {
  "INTRO": {
    "base": "all respondents",
    "instruction": "Record the interview date and time before the start of each interview.",
    "ua": "Добрий день. Ми представляємо ТОВ «FusionLab» (Ф’южнЛаб) – незалежну компанію, що займається маркетинговими дослідженнями. Ми проводимо опитування про захворювання шлунково-кишкового тракту серед населення України.\n\nЧи могли б Ви приділити нам 10 хвилин Вашого часу?\n\nІнформація, яку Ви нам надасте, є суворо конфіденційною та буде використана лише в узагальненому вигляді."
  },
  "Q0": {
    "base": "all respondents",
    "instruction": "SINGLE. Code 2 - screenout",
    "ua": "Чи погоджуєтеся Ви зараз взяти участь тестуванні дизайнів?\n1. Так\n2. Ні"
  },
  "S11": {
    "base": "all respondents",
    "instruction": "MULTI. Read aloud. If any code 1–10 is selected — terminate the interview; code 11 — continue.",
    "ua": "Чи працюєте Ви в одній із цих сфер?\n1. Рекламна агенція або агенція зі зв’язків із громадськістю\n2. Маркетинг / маркетингові дослідження\n3. Газета або журнал, радіо або ТБ\n4. Психологія або соціологія\n5. PR (зв’язки з громадськістю)\n6. Мерчендайзинг, просування медичних препаратів\n7. Фармакологія / фармацевтика\n8. Охорона здоров’я (медичні працівники, медичні представники)\n9. Аптека (фармацевти, провізори)\n10. Дистрибуція медичних препаратів\n11. Нічого з переліченого"
  },
  "S1": {
    "base": "all respondents",
    "instruction": "Single\nTERMINATE IF S1=1",
    "ua": "Вкажіть Вашу стать.\n1. Чоловіча\n2. Жіноча"
  },
  "S2": {
    "base": "all respondents",
    "instruction": "Numeric\nTERMINATE IF <25 OR >55",
    "ua": "Вкажіть Ваш вік.\n_____ років\n\n1. 24 роки і молодше\n2. 25–30 років\n3. 31–40 років\n4. 41–50 років\n5. 51–55 років\n6. 56 років і старше"
  },
  "S3": {
    "base": "all respondents",
    "instruction": "SINGLE. Geography / quota control.",
    "ua": "У якому місті Ви проживаєте?\n1.Вінниця\n2.Луцьк\n3.Дніпро\n4Житомир\n5.Ужгород\n6.Запоріжжя\n7.Івано-Франківськ\n8.Київ\n9.Кропивницький\n10.Львів\n11.Миколаїв\n12.Одеса\n13.Полтава\n14.Рівне\n15.Суми\n16.Тернопіль\n17.Харків\n18.Хмельницький\n19.Черкаси\n20.Чернівці\n21.Чернігів"
  },
  "S4": {
    "base": "all respondents",
    "instruction": "SINGLE. Code 1 - screenout",
    "ua": "Як би Ви оцінили рівень доходу Вашої сім’ї?\n1. Не вистачає грошей на харчування\n2. Вистачає на харчування, але купівля одягу викликає труднощі\n3. Вистачає на поточні витрати, але складно купити велику побутову техніку\n4. Вистачає на велику побутову техніку, але не на автомобіль\n5. Вистачає практично на все, крім дуже дорогих покупок"
  },
  "S7": {
    "base": "all respondents",
    "instruction": "MULTI, no more than 4 answers. If code 1 is not selected — terminate the interview. Code 99 is exclusive.",
    "ua": "Які з наведених груп лікарських засобів Ви особисто приймали протягом останніх 6 місяців?\n1. Ферментні препарати для покращення травлення\n2. Проносні препарати для полегшення закрепу\n3. Лікарські засоби для покращення функції печінки\n4. Знеболювальні препарати\n99. Нічого з переліченого вище"
  },
  "S8": {
    "base": "all respondents",
    "instruction": "SINGLE. Purchase decision maker and primary shopper. If code 3 is selected — terminate the interview.",
    "ua": "Чи купували Ви самостійно ферментні препарати для покращення травлення протягом останніх 6 місяців?\n1. Завжди сама\n2. Іноді я, іноді інші члени сім’ї\n3. Сама не купувала"
  },
  "S9": {
    "base": "all respondents",
    "instruction": "MULTI. Quota: code  1 - 50% Creon® users / other codes - 50% non-users.",
    "ua": "Які з наведених ферментних препаратів Ви приймали?\n1. Креон®\n2. Панжест\n3. Фестал\n4. Мезим\n5. Панкреатин Тернопіль\n6. Ферментаза\n7. Інші"
  },
  "S10": {
    "base": "S9≠1",
    "instruction": "SINGLE. Code 2 — end of interview",
    "ua": "Якщо Вашого препарату не буде у продажу, чи розглянете Ви купівлю Креон® за умови такої самої ціни?\n1. Так\n2. Ні"
  },
  "Q1": {
    "base": "all respondents",
    "instruction": "SINGLE.",
    "ua": "Як часто Ви зазвичай приймаєте ферментні препарати для покращення травлення?\n1. Кілька разів на тиждень\n2. Приблизно раз на тиждень\n3. 2–3 рази на місяць\n4. Приблизно раз на місяць\n5. Рідше одного разу на місяць"
  },
  "Q2": {
    "base": "all respondents",
    "instruction": "MULTI. Rotation of codes 1–7; code 8 (other, open) - always bottom",
    "ua": "У яких ситуаціях Ви зазвичай приймаєте ферментні препарати?\n1. При важкості або відчутті переповненості після їжі\n2. При дискомфорті після їжі\n3. При здутті\n4. Після переїдання\n5. Після жирної / важкої їжі\n6. Під час або після застіль, свят\n7. За рекомендацією лікаря в певних ситуаціях / курсом\n8. Інше, вкажіть ______"
  },
  "Q3": {
    "base": "all respondents",
    "instruction": "GRID, One answer per line. Scale 1–7.",
    "ua": "Що для Вас є найважливішим при виборі ферментного препарату?\n1 = зовсім не важливо; 7 = надзвичайно важливо\n1. Ефективність\n2. Безпека\n3. Довіра до бренду\n4. Рекомендація лікаря\n5. Рекомендація фармацевта\n6. Власний позитивний досвід\n7. Зрозумілість призначення препарату\n8. Зручність застосування\n9. Тривалий ефект\n10. Ціна\n11. Зрозуміла та інформативна упаковка\n12. Швидкість дії"
  },
  "ET0": {
    "base": "all respondents",
    "instruction": "SINGLE. Do not automatically exclude. If proper calibration is not possible, record the technical status of the eye-tracking; continue with the questionnaire section.",
    "ua": "Чи використовуєте Ви зараз засоби корекції зору?\n1. Ні\n2. Окуляри\n3. Контактні лінзи"
  },
  "ET_TEST1_INTRO": {
    "base": "all respondents",
    "instruction": "Show the  shelf for 8–10 seconds. Rotate positions A/B. Rotation plan: to show the shelf with Design A to  50% of respondent s, other 50% will see the shelf with Design B Do not display any questions during the exposure. Eye-tracking heatmap, duration, emotions.",
    "ua": "Зараз Ви побачите зображення аптечної полиці з кількома препаратами для травлення. Будь ласка, розгляньте її так, ніби Ви перебуваєте в аптеці та обираєте відповідний препарат. Спеціально шукати будь-який бренд не потрібно — просто уважно розгляньте полицю."
  },
  "ET1.1": {
    "base": "all respondents",
    "instruction": "MULTI. Do not show the shelf again. Rotation of codes 1–6; code 8 (other, open) and 8 (don't remember) - always bottom",
    "ua": "Які з препаратів на полиці Ви запам’ятали?\n1. Креон®\n2. Фестал\n3. Мезим\n4. Панжест\n5.  Ферментаза\n6. Панкреатин\n7. Інший препарат (ЗАПИШIТ) _________________\n8. Не пам’ятаю жодного"
  },
  "ET1.2": {
    "base": "all respondents",
    "instruction": "SINGLE. Use the same list as in ET1.1.",
    "ua": "Який препарат Ви помітили першим?"
  },
  "ET1.3": {
    "base": "all respondents",
    "instruction": "SINGLE. Use the same list as in ET1.1.",
    "ua": "Який препарат на цій полиці найбільше привернув Вашу увагу?"
  },
  "ET1.4": {
    "base": "",
    "instruction": "SINGLE. Use the same list as in ET1.1.",
    "ua": "Який препарат Ви насамперед розглянули б для вибору?"
  },
  "ET2_INTRO": {
    "base": "Before each concept A/B",
    "instruction": "Show the concept for 10 seconds. Randomize the A/B order. Do not display questions simultaneously with the packaging.",
    "ua": "Зараз Ви побачите упаковку препарату. Будь ласка, уважно розгляньте її так, як Ви зазвичай розглядаєте упаковку препарату перед купівлею або застосуванням. Після перегляду ми поставимо кілька запитань."
  },
  "ET2.1": {
    "base": "After showing each concept",
    "instruction": "SINGLE.",
    "ua": "Що Ви помітили на упаковці насамперед?\n1. Назву Креон®\n2. Дозування 10 000\n3. Зображення вихору / мінімікросфер\n4. Зображення шлунка / кишечника\n5. Фразу Поліферменти для покращення травлення»\n6. Фразу «Швидко розчиняється у шлунку»\n7. Інформацію про призначення препарату\n8. Кількість капсул / формат упаковки\n9. Логотип виробника\n10. Інше\n11. Не можу пригадати"
  },
  "ET2.2": {
    "base": "After showing each concept",
    "instruction": "MULTI.Use the same list as in ET2.1.",
    "ua": "Які елементи упаковки Ви запам’ятали?"
  },
  "ET2.3": {
    "base": "After showing each concept",
    "instruction": "SINGLE. Use the same list as in ET2.1.",
    "ua": "Що на упаковці було найлегше помітити?"
  },
  "ET2.4": {
    "base": "After showing each concept",
    "instruction": "MULTI. Use codes 1–9 from the ET2.1 list.",
    "ua": "Що на упаковці було важко помітити або прочитати?"
  },
  "P1": {
    "base": "Loop A/B",
    "instruction": "SINGLE, 1–7 scale. Keep showing the corresponding packaging during evaluation.",
    "ua": "Наскільки Вам загалом подобається дизайн цієї упаковки?\n1 = зовсім не подобається; 7 = дуже подобається"
  },
  "P2": {
    "base": "Loop A/B",
    "instruction": "GRID, one answer per row. 1–7 scale. Rotate statements within thematic groups; keep group order.",
    "ua": "Наскільки Ви погоджуєтеся або не погоджуєтеся з твердженнями про цю упаковку?\n1 = зовсім не згодна; 7 = повністю згодна\n1. Дизайн упаковки виглядає сучасним.\n2. Ця упаковка відповідає моїм очікуванням від препарату Креон®.\n3. Ця упаковка виглядає як упаковка лікарського препарату, а не дієтичної добавки.\n4. Ця упаковка надає чітку та зрозумілу інформацію.\n5. Креон® у цій упаковці сприймається як експерт у категорії препаратів для травлення.\n6. Ця упаковка чітко пояснює, для чого призначений препарат і які в нього переваги.\n7. Ця упаковка відрізняється від інших препаратів для травлення.\n8. Цю упаковку буде легко знайти серед інших препаратів на аптечній полиці.\n9. Колір і дизайн цієї упаковки добре вирізняються серед інших упаковок.\n10. Бренд Креон® легко впізнати за цією упаковкою.\n11. З цієї упаковки зрозуміло, що у складі Креон® є кілька видів ферментів.\n12. Назву препарату легко прочитати.\n13. Ця упаковка викликає довіру.\n14. Ця упаковка створює враження високої якості препарату.\n15. Ця упаковка вказує на тривалий ефект препарату.\n16. Препарат у цій упаковці виглядає безпечним.\n17. Ця упаковка відповідає репутації бренду Креон®.\n18. Ця упаковка викликає впевненість в ефективності препарату.\n19. Ця упаковка створює відчуття турботи про пацієнта.\n20. Ця упаковка передає відчуття швидкої дії препарату\n21. Препарат у цій упаковці виглядає інноваційним.\n22. Препарат у цій упаковці виглядає преміальним."
  },
  "P3": {
    "base": "Loop A/B",
    "instruction": "GRID, one answer per row. 1–7 scale.",
    "ua": "Наскільки легко за цією упаковкою зрозуміти таку інформацію?\n1 = зовсім незрозуміло; 7 = цілком зрозуміло\n1. Для чого призначений препарат\n2. У яких ситуаціях його можна застосовувати\n3. Яке дозування препарату\n4. Які основні переваги має препарат\n5. Ключову інформацію на упаковці загалом"
  },
  "P4": {
    "base": "Loop A/B",
    "instruction": "SINGLE, 1–7 scale.",
    "ua": "Наскільки легко Ви зможете відрізнити це дозування Креон® від інших дозувань препарату за оформленням упаковки?\n1 = дуже складно відрізнити; 7 = дуже легко відрізнити"
  },
  "P5a": {
    "base": "Loop A/B",
    "instruction": "SINGLE.",
    "ua": "Чи звернули Ви увагу на зображення вихору з мінімікросферами на упаковці?\n1. Так\n2. Ні / не впевнена"
  },
  "P5b": {
    "base": "Loop A/B",
    "instruction": "MULTI. Rotate codes 1-8; \ncodes 8-11 at the bottom. Code 11 - open",
    "ua": "Як Ви сприймаєте це зображення?\n1. Воно допомагає зрозуміти принцип дії препарату\n2. Воно показує особливу технологію / форму препарату\n3. Воно створює відчуття ефективної дії препарату\n4. Воно створює відчуття швидкої дії препарату\n5. Воно передає ідею взаємодії / змішування препарату з їжею\n6. Воно робить препарат більш сучасним\n7. Воно робить препарат більш інноваційним\n8. Воно посилює відчуття експертності препарату\n9. Воно є лише елементом дизайну і не несе для мене конкретного змісту\n10. Мені незрозуміло, що означає це зображення\n11. Інше, вкажіть ______"
  },
  "P5c": {
    "base": "Loop A/B",
    "instruction": "SINGLE, 1–7 scale.",
    "ua": "Наскільки добре зображення вихору з мінімікросферами допомагає передати переваги Креон®?\n1 = зовсім не допомагає; 7 = дуже добре допомагає"
  },
  "P6a": {
    "base": "Loop A/B",
    "instruction": "MULTI. Rotate codes 1-2, code 3 always at bottom",
    "ua": "Які з наведених повідомлень на упаковці Ви помітили?\n1. Поліферменти для покращення травлення»\n2. «Швидко розчиняється у шлунку»\n3. Не помітила жодного"
  },
  "P6b": {
    "base": "Loop A/B; for each claim present",
    "instruction": "GRID / LOOP, 1–7 scale. ",
    "ua": "Наскільки це повідомлення Вам зрозуміле? 1 = зовсім не зрозуміло; 7 = дуже добре зрозуміло"
  },
  "P6c": {
    "base": "Loop A/B; for each claim present",
    "instruction": "GRID / LOOP, 1–7 scale. ",
    "ua": "Наскільки це повідомлення викликає довіру? 1 = зовсім не викликає; 7 = дуже добре викликає"
  },
  "P6d": {
    "base": "Loop A/B; for each claim present",
    "instruction": "GRID / LOOP, 1–7 scale.",
    "ua": "Наскільки воно важливе / актуальне особисто для Вас при виборі ферментного препарату? 1 = зовсім не важливо; 7 = дуже важливо"
  },
  "P6e": {
    "base": "Loop A/B; for each claim present",
    "instruction": "GRID / LOOP, 1–7 scale. ",
    "ua": "Наскільки це повідомлення посилює бажання обрати Креон®? 1 = зовсім не посилює; 7 = дуже посилює"
  },
  "P7": {
    "base": "Loop A/B",
    "instruction": "GRID, one answer per row. 1–7 scale.",
    "ua": "Наскільки Вам подобаються такі елементи цієї упаковки? 1 = зовсім не подобається; 7 = дуже подобається\n1. Кольорова палітра упаковки\n2. Написання та оформлення назви Креон®\n3. Розмір і читабельність назви Креон®\n4. Позначення дозування\n5. Зображення вихору з мінімікросферами\n6. Розташування інформації на упаковці\n7. Загальна композиція дизайну\n8. Дизайн упаковки загалом"
  },
  "P8a": {
    "base": "Loop A/B",
    "instruction": "SINGLE, 1–5 scale.",
    "ua": "Якби за потреби Ви побачили Креон® у такій упаковці в аптеці, наскільки ймовірно, що Ви обрали б його?\n1. Точно не обрала б\n2. Скоріше не обрала б\n3. Можливо, обрала б, можливо, ні\n4. Скоріше обрала б\n5. Точно обрала б"
  },
  "P8b": {
    "base": "Loop A/B",
    "instruction": "SINGLE,1–7 scale.",
    "ua": "Наскільки Вам хотілося б використовувати Креон® саме в такій упаковці? 1 = зовсім не хотілося б; 7 = дуже хотілося б"
  },
  "P8c": {
    "base": "Loop A/B",
    "instruction": "SINGLE,1–7 scale.",
    "ua": "Наскільки Ви були б готові рекомендувати Креон® у такій упаковці близькій людині, якщо їй підходить такий препарат? 1 = зовсім не готова; 7 = повністю готова"
  },
  "P9": {
    "base": "Loop A/B",
    "instruction": "MULTI. Rotate codes 1-10, code 11 (other, open) and 12  always at bottom",
    "ua": "Чи є в цій упаковці щось, що Вас насторожує?\n1. Виглядає надто серйозно для лікарського препарату\n2. Виглядає недостатньо серйозно для лікарського препарату\n3. Нагадує дієтичну добавку\n4. Недостатньо впізнавана як Креон®\n5. Незрозуміле призначення препарату\n6. Дозування недостатньо помітне\n7. Надто мало інформації\n8. Надто багато інформації\n9. Дизайн виглядає надто складним / перевантаженим\n10. Дизайн виглядає надто простим\n11. Інше, вкажіть ______\n12. Нічого не бентежить"
  },
  "C1": {
    "base": "After rating A and B; also show the current packaging",
    "instruction": "SINGLE.",
    "ua": "Яка з упаковок Вам загалом подобається більше?\n1. Упаковка A\n2. Упаковка B\n3. Поточна упаковка Креон®\n4. Подобаються однаково\n5. Не подобається жодна"
  },
  "C2": {
    "base": "After rating A and B; also show the current packaging",
    "instruction": "GRID. For each row: A / B / текущая упаковка / одинаково  / ни одна",
    "ua": "Яка упаковка краще відповідає кожному опису?\n1. Краще відповідає бренду Креон®\n2. Виглядає більш професійною та лікарською\n3. Викликає більше довіри\n4. Більше говорить про ефективність препарату\n5. Краще пояснює призначення препарату\n6. Більше говорить про швидкість дії препарату\n7. Краще вирізняється серед конкурентів\n8. Краще передає переваги Креон®\n9. Виглядає більш сучасною\n10. Виглядає більш інноваційною\n11. Викликає більше бажання обрати препарат"
  },
  "C3": {
    "base": "After rating A and B; also show the current packaging",
    "instruction": "GRID, rate A and B on a 1–7 scale.",
    "ua": "Наскільки кожна нова упаковка зберігає впізнаваність звичного Креон®?\n1 = зовсім не зберігає; 7 = повністю зберігає"
  },
  "C4": {
    "base": "After rating A and B; also show the current packaging",
    "instruction": "SINGLE.",
    "ua": "Якому варіанту упаковки Ви загалом надаєте перевагу?\n1. Упаковка A \n2. Упаковка B \n3. Поточна упаковка Креон®\n4. Не віддаю перевагу жодному варіанту"
  },
  "C5": {
    "base": "After rating A and B; also show the current packaging",
    "instruction": "SINGLE.",
    "ua": "Яка упаковка найкраще поєднує сучасний дизайн і впізнаваність Креон®?\n1. Упаковка A \n2. Упаковка B \n3. Поточна упаковка Креон®\n4. Немає відмінностей"
  },
  "C6": {
    "base": "After rating A and B; also show the current packaging",
    "instruction": "SINGLE.",
    "ua": "Яку упаковку Креон® Ви хотіли б бачити в аптеці в майбутньому?\n1. Упаковку A \n2. Упаковку B \n3. Поточну упаковку Креон®\n4. Не хотіла б бачити жодний варіант"
  },
  "C7": {
    "base": "all respondents",
    "instruction": "MULTI, no more than 3 answers.",
    "ua": "Які елементи вибраної Вами упаковки особливо важливо зберегти у фінальному дизайні упаковки Креон®? \n1. Кольорова гама\n2. Добре помітна назва Креон®\n3. Шрифт / оформлення назви\n4. Чітко позначене дозування\n5. Вихор із мінімікросферами\n6. Основне повідомлення / claim\n7. Структура та розташування інформації\n8. Загальний професійний / медичний вигляд\n9. Інше, вкажіть ______"
  },
  "C8": {
    "base": "all respondents",
    "instruction": "OPEN.",
    "ua": "Чому Ви надали перевагу саме цьому варіанту упаковки?"
  }
};

export default CREON_CONTENT_UA;
